import styled, { useTheme } from "styled-components";
import type { TukipyyntoTila } from "../types";
import { useTranslation } from "react-i18next";

interface TagProps {
  $bg: string;
  $fg: string;
}

// Kulmikas kevyt-värinen tag — käytössä kaikkialla yhtenäisesti.
const Tag = styled.span<TagProps>`
  display: inline-block;
  padding: ${({ theme }) => theme.spacing.xxs}
    ${({ theme }) => theme.spacing.xs};
  font: ${({ theme }) => theme.typography.actionElementInnerTextBold};
  font-size: 0.6875rem;
  line-height: 1.4;
  background: ${({ $bg }) => $bg};
  color: ${({ $fg }) => $fg};
  white-space: nowrap;
  flex-shrink: 0;
`;

export default function TilaBadge({ tila }: { tila: TukipyyntoTila }) {
  const theme = useTheme();
  const { t } = useTranslation("common");
  const variants: Record<TukipyyntoTila, TagProps> = {
    avoin: { $bg: theme.colors.alertLight1, $fg: theme.colors.alertBase },
    käsittelyssä: {
      $bg: theme.colors.highlightLight2,
      $fg: theme.colors.highlightDark1,
    },
    ratkaistu: {
      $bg: theme.colors.successSecondary,
      $fg: theme.colors.successDark1,
    },
    "self-resolved": {
      $bg: theme.colors.depthLight2,
      $fg: theme.colors.depthDark1,
    },
  };
  return <Tag {...variants[tila]}>{t(`tilat.${tila}`)}</Tag>;
}
